import React, { useState } from "react";
import publicApi from "@/lib/publicApi";
import { ThumbsUp, ThumbsDown, Check, Loader2 } from "lucide-react";

// PROMPT 9E — small "Was this helpful?" control on public FAQ answers.
export default function FaqFeedback({ slug, franchise }) {
  const [stage, setStage] = useState("ask"); // ask | comment | done
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async (helpful) => {
    setBusy(true);
    try {
      await publicApi.post(`/public/faq/${slug}/feedback`, {
        helpful,
        comment: helpful ? null : (comment.trim() || null),
        page_path: typeof window !== "undefined" ? window.location.pathname : null,
        franchise: franchise || null,
      });
    } catch { /* fire-and-forget */ }
    setBusy(false);
    setStage("done");
  };

  if (stage === "done") return (
    <div data-testid="faq-feedback-done" className="mt-8 rounded-xl border border-[#E6EDF2] bg-white p-4 flex items-center gap-2 text-[14px] font-medium text-[#2F7D5A]">
      <Check size={16} /> Thank you — your feedback helps other families.
    </div>
  );

  return (
    <div data-testid="faq-feedback" className="mt-8 rounded-xl border border-[#E6EDF2] bg-white p-4">
      <div className="flex items-center gap-3 flex-wrap">
        <span className="text-[15px] font-semibold text-[#1C4358]">Was this helpful?</span>
        <button type="button" data-testid="faq-feedback-yes" disabled={busy} onClick={() => send(true)}
          className="mmm-tap inline-flex items-center gap-1.5 px-4 h-10 rounded-full border border-[#2F7D5A]/30 text-[#2F7D5A] font-semibold text-[14px] hover:bg-[#2F7D5A]/8 transition-colors">
          <ThumbsUp size={15} /> Yes
        </button>
        <button type="button" data-testid="faq-feedback-no" disabled={busy} onClick={() => setStage("comment")}
          className="mmm-tap inline-flex items-center gap-1.5 px-4 h-10 rounded-full border border-[#9C1E22]/30 text-[#9C1E22] font-semibold text-[14px] hover:bg-[#9C1E22]/8 transition-colors">
          <ThumbsDown size={15} /> No
        </button>
      </div>
      {stage === "comment" && (
        <div className="mt-3">
          <label className="text-[13px] text-[#4B5563]">What was missing?</label>
          <textarea data-testid="faq-feedback-comment" value={comment} onChange={(e) => setComment(e.target.value)} rows={3}
            placeholder="Tell us what would have helped (optional)…"
            className="mt-1 w-full rounded-lg border border-[#E6EDF2] p-3 text-[14px] outline-none focus:border-[#1C4358]/40" />
          <button type="button" data-testid="faq-feedback-submit" disabled={busy} onClick={() => send(false)}
            className="mmm-tap mt-2 inline-flex items-center gap-1.5 px-5 h-10 rounded-full bg-[#1C4358] text-white font-semibold text-[14px]">
            {busy ? <Loader2 size={14} className="animate-spin" /> : null} Send feedback
          </button>
        </div>
      )}
    </div>
  );
}
